var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "item hotel",
      class: _vm.containerClasses,
      attrs: {
        "data-page-id": _vm.page.ID,
        "aria-label": "Details for " + _vm.page.TITLE + " Room",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "img",
          style: _vm.imageStyles,
          attrs: { "data-img-src": _vm.page.IMG_SRC },
        },
        [
          _c("hotel-room-icons", {
            attrs: {
              "room-data": _vm.roomData,
              "room-availability-data": _vm.roomAvailabilityData,
              page: _vm.page,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "tooltip-dock-bottom",
          attrs: { "data-tooltip": _vm.page.TITLE },
        },
        [
          _c("span", { staticClass: "clip" }, [
            _vm._v("\n    " + _vm._s(_vm.page.TITLE) + "\n  "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hotel-room-call-to-action", {
        attrs: {
          page: _vm.page,
          "offer-codes": _vm.offerCodes,
          "show-learn-more-button": "",
          "add-resort-fee-to-room-rate": "",
        },
      }),
      _vm._v(" "),
      _c("table", { staticClass: "details", attrs: { role: "presentation" } }, [
        _c("tbody", [
          _c("tr", [
            _c("td", { staticClass: "filter-match-sq_ft" }, [
              _vm._v("SIZE"),
              _c("br"),
              _vm._v(_vm._s(_vm.roomSqFt) + " sq. ft."),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "filter-match-bed_type" }, [
              _vm._v(_vm._s(_vm.bedType)),
              _c("br"),
              _vm._v(_vm._s(_vm.bedCount)),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "filter-match-bath_type" }, [
              _vm._v("BATHS"),
              _c("br"),
              _vm._v(_vm._s(_vm.searchData["BATH-COUNT"])),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }